export default {
  'app.editor.flow.title': 'Editor de diagrama de flujo',
  'app.editor.flow.description':
    'El diagrama de flujo es una excelente manera de representar la idea del algoritmo.',
  'app.editor.koni.title': 'Editor de topologia',
  'app.editor.koni.description':
    'El diagrama de topología se refiere al diagrama de estructura de red compuesto por dispositivos de nodo de red y medios de comunicación.',
  'app.editor.mind.title': 'Editor de mapas cerebrales',
  'app.editor.mind.description':
    'El mapa cerebral es una herramienta de pensamiento gráfico eficaz para expresar el pensamiento divergente. Es simple pero efectivo y es una herramienta de pensamiento práctico.',
};
